var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFishingVest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#acd640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#8bc353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6417,
    stopColor: "#55a373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.731,
    x2: 243.276,
    xlinkHref: "#lg1",
    y1: -20.484,
    y2: 246.228
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#0a6d8d",
    stopOpacity: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9063,
    stopColor: "#074d65",
    stopOpacity: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg2",
    y1: 95.305,
    y2: -29.207
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.297,
    x2: 387.923,
    xlinkHref: "#lg1",
    y1: 258.901,
    y2: 416.898
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.136,
    x2: 637.514,
    xlinkHref: "#lg1",
    y1: 198.708,
    y2: 481.271
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.495,
    x2: 126.495,
    xlinkHref: "#lg1",
    y1: 8,
    y2: 94.209
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.505,
    x2: 383.505,
    xlinkHref: "#lg1",
    y1: 8,
    y2: 94.209
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg2",
    y1: 466.117,
    y2: 563.096
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.571,
    x2: 236.517,
    xlinkHref: "#lg1",
    y1: 146.555,
    y2: 165.816
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.31,
    x2: 494.806,
    xlinkHref: "#lg1",
    y1: 154.161,
    y2: 147.494
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.573,
    x2: 102.573,
    xlinkHref: "#lg2",
    y1: 377.253,
    y2: 219.753
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.257,
    x2: 145.757,
    xlinkHref: "#lg2",
    y1: 481.322,
    y2: 369.822
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.456,
    x2: 288.456,
    xlinkHref: "#lg2",
    y1: 387.85,
    y2: 180.35
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.979,
    x2: 340.479,
    xlinkHref: "#lg2",
    y1: 496.562,
    y2: 397.562
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.622,
    x2: 164.556,
    xlinkHref: "#lg1",
    y1: 271.101,
    y2: 377.699
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.981,
    x2: 120.026,
    xlinkHref: "#lg2",
    y1: 313.984,
    y2: 313.984
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.864,
    x2: 165.685,
    xlinkHref: "#lg2",
    y1: 313.984,
    y2: 313.984
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.381,
    x2: 161.498,
    xlinkHref: "#lg1",
    y1: 256.232,
    y2: 315.87
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.95,
    x2: 139.173,
    xlinkHref: "#lg2",
    y1: 299.968,
    y2: 263.19
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.559,
    x2: 158.994,
    xlinkHref: "#lg3",
    y1: 276.656,
    y2: 283.091
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -6882.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -2931.19,
    x2: -2927.535,
    xlinkHref: "#lg3",
    y1: -7165.005,
    y2: -7161.351
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.622,
    x2: 164.556,
    xlinkHref: "#lg1",
    y1: 398.231,
    y2: 504.829
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.981,
    x2: 120.026,
    xlinkHref: "#lg2",
    y1: 441.115,
    y2: 441.115
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.864,
    x2: 165.685,
    xlinkHref: "#lg2",
    y1: 441.115,
    y2: 441.115
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.381,
    x2: 161.498,
    xlinkHref: "#lg1",
    y1: 383.362,
    y2: 443.001
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.95,
    x2: 139.173,
    xlinkHref: "#lg2",
    y1: 427.098,
    y2: 390.32
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.559,
    x2: 158.994,
    xlinkHref: "#lg3",
    y1: 403.786,
    y2: 410.221
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -6882.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -2931.19,
    x2: -2927.535,
    xlinkHref: "#lg3",
    y1: -7292.135,
    y2: -7288.481
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.957,
    x2: 359.89,
    xlinkHref: "#lg1",
    y1: 271.101,
    y2: 377.699
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.315,
    x2: 315.36,
    xlinkHref: "#lg2",
    y1: 313.984,
    y2: 313.984
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.198,
    x2: 361.019,
    xlinkHref: "#lg2",
    y1: 313.984,
    y2: 313.984
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.715,
    x2: 356.832,
    xlinkHref: "#lg1",
    y1: 256.232,
    y2: 315.87
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.284,
    x2: 334.507,
    xlinkHref: "#lg2",
    y1: 299.968,
    y2: 263.19
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.893,
    x2: 354.328,
    xlinkHref: "#lg3",
    y1: 276.656,
    y2: 283.091
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -6882.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -3126.524,
    x2: -3122.869,
    xlinkHref: "#lg3",
    y1: -7165.005,
    y2: -7161.351
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.957,
    x2: 359.89,
    xlinkHref: "#lg1",
    y1: 398.231,
    y2: 504.829
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.315,
    x2: 315.36,
    xlinkHref: "#lg2",
    y1: 441.115,
    y2: 441.115
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.198,
    x2: 361.019,
    xlinkHref: "#lg2",
    y1: 441.115,
    y2: 441.115
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.715,
    x2: 356.832,
    xlinkHref: "#lg1",
    y1: 383.362,
    y2: 443.001
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.284,
    x2: 334.507,
    xlinkHref: "#lg2",
    y1: 427.098,
    y2: 390.32
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.893,
    x2: 354.328,
    xlinkHref: "#lg3",
    y1: 403.786,
    y2: 410.221
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(-1 0 0 -1 -2772.562 -6882.28)",
    gradientUnits: "userSpaceOnUse",
    x1: -3126.524,
    x2: -3122.869,
    xlinkHref: "#lg3",
    y1: -7292.135,
    y2: -7288.481
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.19,
    x2: 161.19,
    xlinkHref: "#lg1",
    y1: 205.52,
    y2: 144.978
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientTransform: "matrix(-1 0 0 -1 318.5 383.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 157.31,
    x2: 157.31,
    xlinkHref: "#lg1",
    y1: 197.938,
    y2: 168.687
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.795,
    x2: 42.073,
    xlinkHref: "#lg2",
    y1: 233.662,
    y2: 152.419
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.624,
    x2: 136.624,
    xlinkHref: "#lg4",
    y1: 188.069,
    y2: 216.639
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48b2e3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.562,
    x2: 124.756,
    xlinkHref: "#lg5",
    y1: 203.232,
    y2: 189.749
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.624,
    x2: 136.624,
    xlinkHref: "#lg5",
    y1: 199.489,
    y2: 204.388
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5dbff"
  }))), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 391.884,
    x2: 409.92,
    xlinkHref: "#lg6",
    y1: 323.144,
    y2: 333.805
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 406.889,
    x2: 384.755,
    xlinkHref: "#lg6",
    y1: 331.446,
    y2: 319.992
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 410.435,
    x2: 400.524,
    xlinkHref: "#lg6",
    y1: 322.122,
    y2: 316.993
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8fc5e9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56a4c8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2d8db1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147ea2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.096,
    x2: 133.114,
    xlinkHref: "#lg7",
    y1: 196.907,
    y2: 193.083
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.581,
    x2: 140.127,
    xlinkHref: "#lg6",
    y1: 191.895,
    y2: 191.895
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.624,
    x2: 136.624,
    xlinkHref: "#lg7",
    y1: 223.898,
    y2: 234.527
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.81,
    x2: 348.81,
    xlinkHref: "#lg1",
    y1: 205.52,
    y2: 144.978
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientTransform: "matrix(-1 0 0 -1 318.5 383.25)",
    gradientUnits: "userSpaceOnUse",
    x1: -30.31,
    x2: -30.31,
    xlinkHref: "#lg1",
    y1: 197.938,
    y2: 168.687
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.414,
    x2: 229.693,
    xlinkHref: "#lg2",
    y1: 233.662,
    y2: 152.419
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.243,
    x2: 324.243,
    xlinkHref: "#lg4",
    y1: 188.069,
    y2: 216.639
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.182,
    x2: 312.376,
    xlinkHref: "#lg5",
    y1: 203.232,
    y2: 189.749
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.243,
    x2: 324.243,
    xlinkHref: "#lg5",
    y1: 199.489,
    y2: 204.388
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 524.551,
    x2: 542.587,
    xlinkHref: "#lg6",
    y1: 455.811,
    y2: 466.472
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 539.556,
    x2: 517.422,
    xlinkHref: "#lg6",
    y1: 464.113,
    y2: 452.659
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -377.44 260.66)",
    gradientUnits: "userSpaceOnUse",
    x1: 543.102,
    x2: 533.191,
    xlinkHref: "#lg6",
    y1: 454.789,
    y2: 449.66
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.716,
    x2: 320.734,
    xlinkHref: "#lg7",
    y1: 196.907,
    y2: 193.083
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.2,
    x2: 327.747,
    xlinkHref: "#lg6",
    y1: 191.895,
    y2: 191.895
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.243,
    x2: 324.243,
    xlinkHref: "#lg7",
    y1: 223.898,
    y2: 234.527
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.941,
    x2: 255.311,
    xlinkHref: "#lg1",
    y1: 491.971,
    y2: 492.202
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.396,
    x2: 139.73,
    xlinkHref: "#lg1",
    y1: 143.011,
    y2: 171.678
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.83,
    x2: 255.573,
    xlinkHref: "#lg1",
    y1: 491.834,
    y2: 492.403
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.32,
    x2: 374.69,
    xlinkHref: "#lg1",
    y1: 115.849,
    y2: 198.206
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m401.385 146.286c0-46.619 11.601-88.812 30.345-119.311-27.335-11.474-72.365-26.975-102.437-26.975h-148.586c-30.071 0-75.102 15.501-102.437 26.974 18.745 30.499 30.346 72.693 30.346 119.312 0 53.568-15.318 101.292-39.191 132.144v209.953c0 11.938 9.354 21.616 20.894 21.616h329.361c11.539 0 20.894-9.678 20.894-21.616v-209.955c-23.872-30.852-39.189-78.575-39.189-132.142z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.574 487.975v-213.925c-23.872-31.436-39.189-80.061-39.189-134.641 0-38.852 7.764-74.683 20.848-103.448-25.946-6.154-53.383-10.961-74.754-10.961h-184.958c-21.37 0-48.808 4.807-74.753 10.96 13.083 28.766 20.848 64.597 20.848 103.449 0 54.581-15.318 103.207-39.191 134.643v213.923c0 12.164 9.354 22.025 20.894 22.025h329.361c11.539 0 20.894-9.861 20.894-22.025z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.975 17.858c19.73 31.03 31.942 73.959 31.942 121.39 0 54.501-16.124 103.056-41.252 134.446v214.314c0 12.146 9.847 21.993 21.993 21.993h154.715c10.287-.001 18.627-8.341 18.627-18.628v-202.368c0-12.702-2.996-25.232-8.798-36.531-57.868-112.701-65.495-252.474-65.495-252.474h-20.296c-31.653 0-62.663 6.184-91.436 17.858z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.627 510h154.713c12.146 0 21.993-9.846 21.993-21.993v-214.316c-25.127-31.39-41.25-79.944-41.25-134.444 0-47.431 12.211-90.359 31.941-121.389-28.772-11.674-59.783-17.858-91.436-17.858h-20.294s-7.627 139.773-65.495 252.474c-5.802 11.3-8.798 23.829-8.798 36.531v202.368c-.001 10.287 8.339 18.627 18.626 18.627z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.01 34h-34.91c-19.58 0-43.61 3.02-67.65 7.33-3.71-8.4-7.89-16.26-12.47-23.47 28.77-11.68 59.78-17.86 91.43-17.86h20.3s.7 12.89 3.3 34z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.02 17.86c-4.58 7.21-8.76 15.07-12.47 23.47-24.04-4.31-48.07-7.33-67.65-7.33h-34.91c2.6-21.11 3.3-34 3.3-34h20.3c31.65 0 62.66 6.18 91.43 17.86z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.665 375.747v112.26c0 12.146 9.846 21.993 21.993 21.993h346.683c12.146 0 21.993-9.846 21.993-21.993v-112.26z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m113.896 139.247c0-48.54-11.134-92.364-29.024-123.545-3.047-5.31-9.481-7.64-15.207-5.474l-.39.148c-7.008 2.651-10.157 10.883-6.574 17.463 14.568 26.754 23.819 66.733 23.819 111.409 0 56.993-15.054 106.344-36.998 130.342-2.265 2.477-3.421 5.765-3.216 9.115.669 10.955 14.149 15.716 21.582 7.64 27.56-29.944 46.008-84.614 46.008-147.098z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.104 139.247c0-48.54 11.134-92.364 29.024-123.545 3.047-5.31 9.481-7.64 15.207-5.474l.39.148c7.008 2.651 10.157 10.883 6.574 17.463-14.568 26.754-23.819 66.733-23.819 111.409 0 56.993 15.054 106.344 36.998 130.342 2.265 2.477 3.421 5.765 3.216 9.115-.669 10.955-14.149 15.716-21.582 7.64-27.56-29.944-46.008-84.614-46.008-147.098z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m447.706 498.438-231.995-231.995c-1.629-3.743-5.357-4.363-9.699-4.363h-97.358c-5.842 0-8.577 2.736-8.577 8.577v8.655c0 6.574 2.975 12.448 7.646 16.367v43.917c0 5.316.936 9.942 5.272 12.359l141.832 141.832c.103-.792.174-1.594.174-2.415 0 .963.096 1.902.237 2.826l15.565 15.565c.924.141 1.863.237 2.826.237h154.713c8.37 0 15.648-4.678 19.364-11.562z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.627 510h59.141l-117.057-117.057c-1.629-3.743-5.357-4.363-9.699-4.363h-97.358c-5.842 0-8.577 2.736-8.577 8.577v8.655c0 6.574 2.975 12.448 7.646 16.367v43.917c0 5.316.936 9.942 5.272 12.359l31.544 31.545h91.834c10.287 0 18.627-8.34 18.627-18.627 0 10.287 8.34 18.627 18.627 18.627z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.33 305.72v182.29c0 1.83-.22 3.6-.65 5.3l-141.35-141.35c-4.34-2.42-5.27-7.05-5.27-12.36v-43.92c-4.67-3.92-7.65-9.79-7.65-16.37v-8.65c0-5.84 2.74-8.58 8.58-8.58h97.36c4.34 0 8.07.62 9.7 4.36z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.33 432.22v55.79c0 1.83-.22 3.6-.65 5.3-2.36 9.58-11.02 16.69-21.34 16.69h-88.47l-31.54-31.54c-4.34-2.42-5.27-7.05-5.27-12.36v-43.92c-4.67-3.92-7.65-9.79-7.65-16.37v-8.65c0-5.84 2.74-8.58 8.58-8.58h97.36c4.34 0 8.07.62 9.7 4.36z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.797 353.743h-74.928c-7.813 0-14.147-6.334-14.147-14.147v-65.372h103.221v65.372c0 7.814-6.333 14.147-14.146 14.147z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.683 274.225h45.299v79.518h-45.299z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.947 274.221v65.373c0 7.81-6.342 14.153-14.153 14.153h-14.807v-79.526z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.23 300.672h-75.794c-11.796 0-21.359-9.563-21.359-21.359v-8.655c0-5.842 4.736-10.577 10.577-10.577h97.358c5.842 0 10.577 4.736 10.577 10.577v8.655c0 11.796-9.563 21.359-21.359 21.359z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.73 324.86c-5.368 3.436-12.404 2.673-16.91-1.834l-32.615-32.615c-2.613-2.474-4.033-5.975-4.033-9.858 0-7.337 6.028-13.366 13.365-13.365 3.883 0 7.384 1.42 9.858 4.033l32.615 32.615c6.127 6.129 5.019 16.352-2.28 21.024z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 156.43,
    cy: 280.527,
    fill: "url(#SVGID_19_)",
    r: 13.575
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.43,
    cy: 280.527,
    fill: "url(#SVGID_20_)",
    r: 7.709
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.797 480.874h-74.928c-7.813 0-14.147-6.334-14.147-14.147v-65.372h103.221v65.372c0 7.813-6.333 14.147-14.146 14.147z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.683 401.355h45.299v79.518h-45.299z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.947 401.352v65.373c0 7.81-6.342 14.153-14.153 14.153h-14.807v-79.526z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.23 427.802h-75.794c-11.796 0-21.359-9.563-21.359-21.359v-8.655c0-5.842 4.736-10.577 10.577-10.577h97.358c5.842 0 10.577 4.736 10.577 10.577v8.655c0 11.796-9.563 21.359-21.359 21.359z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.73 451.991c-5.368 3.436-12.404 2.673-16.91-1.834l-32.615-32.615c-2.613-2.474-4.033-5.975-4.033-9.858 0-7.337 6.028-13.366 13.365-13.365 3.883 0 7.384 1.42 9.858 4.033l32.615 32.615c6.127 6.128 5.019 16.352-2.28 21.024z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 156.43,
    cy: 407.657,
    fill: "url(#SVGID_26_)",
    r: 13.575
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.43,
    cy: 407.657,
    fill: "url(#SVGID_27_)",
    r: 7.709
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.131 353.743h-74.928c-7.813 0-14.147-6.334-14.147-14.147v-65.372h103.221v65.372c0 7.814-6.333 14.147-14.146 14.147z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.017 274.225h45.299v79.518h-45.299z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.281 274.221v65.373c0 7.81-6.342 14.153-14.153 14.153h-14.807v-79.526z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.564 300.672h-75.794c-11.796 0-21.359-9.563-21.359-21.359v-8.655c0-5.842 4.736-10.577 10.577-10.577h97.358c5.842 0 10.577 4.736 10.577 10.577v8.655c0 11.796-9.562 21.359-21.359 21.359z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392.064 324.86c-5.368 3.436-12.404 2.673-16.91-1.834l-32.615-32.615c-2.613-2.474-4.033-5.975-4.033-9.858 0-7.337 6.028-13.366 13.365-13.365 3.883 0 7.384 1.42 9.858 4.033l32.615 32.615c6.127 6.129 5.019 16.352-2.28 21.024z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 351.764,
    cy: 280.527,
    fill: "url(#SVGID_33_)",
    r: 13.575
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.764,
    cy: 280.527,
    fill: "url(#SVGID_34_)",
    r: 7.709
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.131 480.874h-74.928c-7.813 0-14.147-6.334-14.147-14.147v-65.372h103.221v65.372c0 7.813-6.333 14.147-14.146 14.147z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.017 401.355h45.299v79.518h-45.299z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.281 401.352v65.373c0 7.81-6.342 14.153-14.153 14.153h-14.807v-79.526z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.564 427.802h-75.794c-11.796 0-21.359-9.563-21.359-21.359v-8.655c0-5.842 4.736-10.577 10.577-10.577h97.358c5.842 0 10.577 4.736 10.577 10.577v8.655c0 11.796-9.562 21.359-21.359 21.359z",
    fill: "url(#SVGID_38_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392.064 451.991c-5.368 3.436-12.404 2.673-16.91-1.834l-32.615-32.615c-2.613-2.474-4.033-5.975-4.033-9.858 0-7.337 6.028-13.366 13.365-13.365 3.883 0 7.384 1.42 9.858 4.033l32.615 32.615c6.127 6.128 5.019 16.352-2.28 21.024z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 351.764,
    cy: 407.657,
    fill: "url(#SVGID_40_)",
    r: 13.575
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.764,
    cy: 407.657,
    fill: "url(#SVGID_41_)",
    r: 7.709
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.305 203.02h-70.229c-4.079 0-7.386-3.307-7.386-7.386v-7.479c0-4.079 3.307-7.386 7.386-7.386h70.229c4.079 0 7.386 3.307 7.386 7.386v7.479c-.001 4.079-3.307 7.386-7.386 7.386z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.263 186.52h69.854c2.747 0 4.974 2.227 4.974 4.974v.801c0 2.747-2.227 4.974-4.974 4.974h-69.854c-2.747 0-4.974-2.227-4.974-4.974v-.801c0-2.747 2.227-4.974 4.974-4.974z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.266 180.765c-.867-1.201-2.27-.99-3.865-.99h-13.555c-2.638 0-3.776 1.138-3.776 3.776v16.688c0 1.376.59 2.607 1.521 3.478l-1.715 20.115c-.177 2.076-.25 3.97 1.269 5.145l53.972 53.972c1.069 1.395 2.75 2.305 4.66 2.305h11.797c3.438 0 6.141-2.944 5.849-6.37l-1.715-20.115c.931-.871 1.521-2.102 1.521-3.478v-16.688c0-1.595-.789-2.998-1.99-3.865z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m143.401 205.015h-13.555c-2.638 0-4.776-2.138-4.776-4.776v-16.688c0-2.638 2.138-4.776 4.776-4.776h13.555c2.638 0 4.776 2.138 4.776 4.776v16.688c0 2.638-2.138 4.776-4.776 4.776z",
    fill: "url(#SVGID_45_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.846 205.015h13.555c2.638 0 4.776-2.138 4.776-4.776v-6.611l-8.928-8.928c-.275-.439-.761-.433-1.317-.433h-2.617c-.859 0-1.257.398-1.257 1.257v3.759h-1.168c-2.852 0-4.93 1.885-5.173 4.726l-.829 9.722c.853.796 1.699 1.284 2.958 1.284z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.07 195.751v4.488c0 2.638 2.138 4.776 4.776 4.776h13.555c2.638 0 4.776-2.138 4.776-4.776v-4.488z",
    fill: "url(#SVGID_47_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.371 223.832-2.543-29.822c-.243-2.841-2.619-5.024-5.471-5.024h-7.467c-2.852 0-5.228 2.183-5.471 5.024l-2.543 29.822c-.292 3.427 2.411 6.371 5.849 6.371h11.797c3.438-.001 6.141-2.944 5.849-6.371zm-11.748-21.07c-1.822 0-3.299-1.476-3.299-3.299 0-1.821 1.476-3.297 3.299-3.297 1.822 0 3.299 1.476 3.299 3.297 0 1.823-1.476 3.299-3.299 3.299z",
    fill: "url(#SVGID_48_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.571 221.602-1.938-25.15c-.185-2.397-1.995-4.237-4.167-4.237h-5.685c-2.172 0-3.982 1.84-4.167 4.237l-1.938 25.15c-.222 2.89 1.837 5.372 4.456 5.372h8.984c2.619 0 4.677-2.482 4.455-5.372zm-8.948-18.84c-1.822 0-3.299-1.476-3.299-3.299 0-1.821 1.476-3.297 3.299-3.297 1.822 0 3.299 1.476 3.299 3.297 0 1.823-1.476 3.299-3.299 3.299z",
    fill: "url(#SVGID_49_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.623 204.693c2.889 0 5.229-2.342 5.229-5.229 0-2.889-2.341-5.229-5.229-5.229-2.889 0-5.229 2.341-5.229 5.229 0 2.887 2.341 5.229 5.229 5.229zm0-8.528c1.822 0 3.299 1.476 3.299 3.299 0 1.821-1.476 3.297-3.299 3.297-1.822 0-3.299-1.476-3.299-3.297.001-1.822 1.477-3.299 3.299-3.299z",
    fill: "url(#SVGID_50_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.828 194.01c-.243-2.841-2.619-5.024-5.471-5.024h-2.02v7.66c.707.43 1.238 1.119 1.464 1.934l7.015 7.015z",
    fill: "url(#SVGID_51_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.932 199.821h-2.617c-.859 0-1.555-.696-1.555-1.555v-12.741c0-.859.696-1.555 1.555-1.555h2.617c.859 0 1.555.696 1.555 1.555v12.741c0 .858-.696 1.555-1.555 1.555z",
    fill: "url(#SVGID_52_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.876 223.832c-.292 3.427 2.411 6.371 5.849 6.371h11.797c3.439 0 6.141-2.944 5.849-6.371l-.289-3.392h-22.916z",
    fill: "url(#SVGID_53_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.924 203.02h-70.229c-4.079 0-7.386-3.307-7.386-7.386v-7.479c0-4.079 3.307-7.386 7.386-7.386h70.229c4.079 0 7.386 3.307 7.386 7.386v7.479c0 4.079-3.307 7.386-7.386 7.386z",
    fill: "url(#SVGID_54_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.883 186.52h69.854c2.747 0 4.974 2.227 4.974 4.974v.801c0 2.747-2.227 4.974-4.974 4.974h-69.854c-2.747 0-4.974-2.227-4.974-4.974v-.801c-.001-2.747 2.226-4.974 4.974-4.974z",
    fill: "url(#SVGID_55_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.885 180.765c-.867-1.201-2.27-.99-3.865-.99h-13.555c-2.638 0-3.776 1.138-3.776 3.776v16.688c0 1.376.59 2.607 1.521 3.478l-1.715 20.115c-.177 2.076-.25 3.97 1.269 5.145l53.972 53.972c1.069 1.395 2.75 2.305 4.66 2.305h11.797c3.438 0 6.141-2.944 5.849-6.37l-1.715-20.115c.931-.871 1.521-2.102 1.521-3.478v-16.688c0-1.595-.789-2.998-1.99-3.865z",
    fill: "url(#SVGID_56_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331.021 205.015h-13.555c-2.638 0-4.776-2.138-4.776-4.776v-16.688c0-2.638 2.138-4.776 4.776-4.776h13.555c2.638 0 4.776 2.138 4.776 4.776v16.688c-.001 2.638-2.139 4.776-4.776 4.776z",
    fill: "url(#SVGID_57_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.465 205.015h13.555c2.638 0 4.776-2.138 4.776-4.776v-6.611l-8.928-8.928c-.275-.439-.761-.433-1.317-.433h-2.617c-.859 0-1.257.398-1.257 1.257v3.759h-1.168c-2.852 0-4.93 1.885-5.173 4.726l-.829 9.722c.854.796 1.7 1.284 2.958 1.284z",
    fill: "url(#SVGID_58_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.69 195.751v4.488c0 2.638 2.138 4.776 4.776 4.776h13.555c2.638 0 4.776-2.138 4.776-4.776v-4.488z",
    fill: "url(#SVGID_59_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m335.99 223.832-2.543-29.822c-.243-2.841-2.619-5.024-5.471-5.024h-7.467c-2.852 0-5.228 2.183-5.471 5.024l-2.543 29.822c-.292 3.427 2.411 6.371 5.849 6.371h11.797c3.439-.001 6.141-2.944 5.849-6.371zm-11.747-21.07c-1.822 0-3.299-1.476-3.299-3.299 0-1.821 1.476-3.297 3.299-3.297s3.299 1.476 3.299 3.297c-.001 1.823-1.477 3.299-3.299 3.299z",
    fill: "url(#SVGID_60_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.191 221.602-1.938-25.15c-.185-2.397-1.995-4.237-4.167-4.237h-5.686c-2.172 0-3.982 1.84-4.167 4.237l-1.938 25.15c-.222 2.89 1.837 5.372 4.456 5.372h8.984c2.619 0 4.678-2.482 4.456-5.372zm-8.948-18.84c-1.822 0-3.299-1.476-3.299-3.299 0-1.821 1.476-3.297 3.299-3.297s3.299 1.476 3.299 3.297c-.001 1.823-1.477 3.299-3.299 3.299z",
    fill: "url(#SVGID_61_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.243 204.693c2.889 0 5.229-2.342 5.229-5.229 0-2.889-2.341-5.229-5.229-5.229s-5.229 2.341-5.229 5.229c0 2.887 2.34 5.229 5.229 5.229zm0-8.528c1.822 0 3.299 1.476 3.299 3.299 0 1.821-1.476 3.297-3.299 3.297s-3.299-1.476-3.299-3.297c0-1.822 1.477-3.299 3.299-3.299z",
    fill: "url(#SVGID_62_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.447 194.01c-.243-2.841-2.619-5.024-5.471-5.024h-2.02v7.66c.707.43 1.238 1.119 1.464 1.934l7.015 7.015z",
    fill: "url(#SVGID_63_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.552 199.821h-2.617c-.859 0-1.555-.696-1.555-1.555v-12.741c0-.859.696-1.555 1.555-1.555h2.617c.859 0 1.555.696 1.555 1.555v12.741c-.001.858-.697 1.555-1.555 1.555z",
    fill: "url(#SVGID_64_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.495 223.832c-.292 3.427 2.411 6.371 5.849 6.371h11.797c3.439 0 6.141-2.944 5.849-6.371l-.289-3.392h-22.916z",
    fill: "url(#SVGID_65_)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m255 491.37c0 .416-.026.827-.063 1.236.028-.41.063-.819.063-1.236z",
    fill: "url(#SVGID_66_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.88 252.47c-68.534-96.919-85.896-213.862-89.412-244.707-.469-4.115 2.723-7.762 6.865-7.763h.077 20.3s7.62 139.77 65.49 252.47c5.53 10.77 8.51 22.66 8.77 34.75-.36-12.09-4.47-23.98-12.09-34.75z",
    fill: "url(#SVGID_67_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 491.37c0 .417.035.825.062 1.236-.037-.409-.062-.82-.062-1.236z",
    fill: "url(#SVGID_68_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.12 252.47c-7.62 10.77-11.73 22.66-12.09 34.75.26-12.09 3.24-23.98 8.77-34.75 57.87-112.7 65.49-252.47 65.49-252.47h20.3.077c4.141.001 7.334 3.648 6.865 7.763-3.516 30.845-20.878 147.788-89.412 244.707z",
    fill: "url(#SVGID_69_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFishingVest);
export default __webpack_public_path__ + "static/media/icon-fishing-vest.4d8c38ca7ba1a785f0a1ffdfe8802243.svg";
export { ForwardRef as ReactComponent };